import * as React from "react";
import { useContext, useEffect, useState } from "react";

import { useAuth } from "../../../contexts/AuthContext.jsx";
import { alertV2 } from "../../../api/index.js";

import InfoDialog from "./InfoDialog.jsx";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
function MonitorWait({
  data,
  openModal,
  alertId,
  setOpenModal,
  onSuccess,
  actionTaken,
}) {
  const [open, setOpen] = React.useState(false);
  const [textValue, setTextValue] = React.useState("");
  const [waitDuration, setWaitDuration] = React.useState(1);
  const [waitUnit, setWaitUnit] = React.useState("Day");
  const { email } = useAuth();
  const handleChangeValue = (e) => {
    setTextValue(e.target.value);
  };
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  const submitHandler = async () => {
    const payload = {
      email: email,
      event_details: `Has responded to the alarm to ${actionTaken}. `,
      event_name: "Response",
      event_action: actionTaken,
      alert_id: alertId,
      action_detail: JSON.stringify({
        action_completed: `${waitDuration} ${waitUnit}`,
        action_name: actionTaken,
        confirmed_issue: "",
        action_work: `${actionTaken} for ${waitDuration} ${waitUnit}`,
        additional_comment: textValue,
      }),
    };

    const res = await alertV2.addLogAction(alertId, payload, null);
    onSuccess();
    setTextValue("");
    setWaitDuration(1);
    setWaitUnit("Day");
    setOpenModal(false);
    setOpen(false);
  };
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  useEffect(() => {
    if (data) {
      const duration = data.action_completed.split(" ")[0];
      const unit = data.action_completed.split(" ")[1];
      setTextValue(data.additional_comment);
      setWaitDuration(duration);
      setWaitUnit(unit);
    } else {
      setTextValue("");
      setWaitDuration(1);
      setWaitUnit("Day");
    }
  }, [data]);

  return (
    <div>
      <Modal show={open} size={"lg"} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert Response - Monitor and Wait</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              fontSize: "13px",
              position: "relative",
              padding: "20px",
            }}
          >
            <div style={{ display: "flex" }}>
              <div>1. </div>
              <div style={{ marginLeft: "5px" }}>
                Please tell us why you decided to monitor and not take any
                action. We recommend providing additional context. This will
                help us in providing better recommendations in the future.
              </div>
            </div>
            <div style={{ marginLeft: "15px", position: "relative" }}>
              <textarea
                value={textValue}
                disabled={!!data}
                onChange={handleChangeValue}
                cols="30"
                rows="4"
                className={"form-control border-theme"}
                style={{
                  width: "100%",
                  resize: "none",
                  padding: "10px",
                  fontFamily: '"Source Sans Pro", sans-serif',
                  fontSize: "13px",
                }}
              ></textarea>
            </div>
            <div style={{ marginTop: "5px" }}>
              <div>2. How long should we “{actionTaken}”?</div>
              <div className="d-flex p-2">
                <div style={{ marginRight: "10px" }}>
                  <input
                    style={{
                      textAlign: "center",

                      fontFamily: '"Source Sans Pro", sans-serif',
                      fontSize: "13px",
                    }}
                    type="number"
                    disabled={!!data}
                    value={waitDuration}
                    onChange={(e) => setWaitDuration(e.target.value)}
                    min={1}
                    max={100}
                    className="form-control btn btn-sm btn-outline-theme"
                  />
                </div>
                <div>
                  <select
                    disabled={!!data}
                    style={{
                      textAlign: "center",
                      fontSize: "13px",
                    }}
                    value={waitUnit}
                    onChange={(e) => setWaitUnit(e.target.value)}
                    name=""
                    id=""
                    className="form-control btn btn-sm btn-outline-theme"
                  >
                    <option value="Day">Day</option>
                    <option value="Week">Week</option>
                    <option value="Month">Month</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="theme" onClick={submitHandler}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default MonitorWait;
